interface apiHostConfigType {
  [key: string]: string
}
const config: apiHostConfigType = {}
config.amaxNodeApi = process.env.REACT_APP_URL
config.centralizedApi = process.env.REACT_APP_CENTRALIZED_API
config.compareApi = process.env.REACT_APP_COMPARE_API
export default config
